import { useFormContext } from 'react-hook-form';
import { Select } from '@/components/common';
import { HEALTH_POLICY_TENURE_OPTIONS, HEALTH_SUM_INSURED_OPTIONS, type HealthQuoteFormData } from '../../schema';

/**
 * Step 3 of the Health branch: Policy Tenure (1-5 years) + Sum Insured
 * (the fixed set of tiers the brief specifies, ₹7.5L through ₹1Cr-Unlimited).
 */
export function PremiumDetailsStep() {
  const {
    register,
    formState: { errors },
  } = useFormContext<HealthQuoteFormData>();

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Premium Details</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
          Choose the policy tenure and cover amount you&rsquo;re looking for.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Select
            label="Policy Tenure"
            options={HEALTH_POLICY_TENURE_OPTIONS}
            placeholder="Select policy tenure"
            required
            error={errors.policy_term_years?.message}
            {...register('policy_term_years')}
          />
          <Select
            label="Sum Insured"
            options={HEALTH_SUM_INSURED_OPTIONS}
            placeholder="Select sum insured"
            required
            error={errors.sum_insured?.message}
            {...register('sum_insured')}
          />
        </div>
      </div>
    </div>
  );
}
